import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminInquiryMedicationSendResponse, adminInquirySendResponse } from '@api/adminInquiries';

export const handleAdminSupplementSendInquiry = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminSupplementSendInquiry', adminInquirySendResponse);

export const handleAdminMedicationSendInquiry = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminMedicationSendInquiry', adminInquiryMedicationSendResponse);
